import { FuelTextField } from '@frete.com/fuel-react'
import * as Styled from './styled'
import { useRequest } from 'ahooks'
import { Phone } from '~services'
import { ChangeEvent, useState } from 'react'
import { maskJs } from 'mask-js'
import { useNavigate } from 'react-router-dom'
import brazilPhoneCodes from '~constants/brazilPhoneCodes'
import { AxiosError } from 'axios'
import { usePath } from '~hooks'

function AddNumber() {
  const [cellphone, setCellphone] = useState('')
  const [error, setError] = useState(false)
  const { runAsync, loading } = useRequest(Phone.create, { manual: true })
  const navigate = useNavigate()
  const path = usePath()
  const state = cellphone.length >= 15 || error ? (!handleError() ? 'success' : 'error') : 'default'
  const hint = cellphone.length >= 15 || error ? (!handleError() ? '' : handleError()) : ''

  function handleError() {
    const cellphoneWithoutMask = cellphone.replace(/\D/g, '')
    const phoneCode = cellphoneWithoutMask.slice(0, 2)
    const isNotValidBrazilianDDD = !brazilPhoneCodes.includes(phoneCode)
    const hasElevenDigits = cellphoneWithoutMask.length === 11
    const isThirdNumberEqualNine = cellphoneWithoutMask.charAt(2) === '9'
    const isEmpty = !cellphoneWithoutMask.length
    let error = ''

    if (isEmpty) {
      error = 'Informe o número do celular.'
    } else if (isNotValidBrazilianDDD) {
      error = 'DDD inválido.'
    } else if (!hasElevenDigits || !isThirdNumberEqualNine) {
      error = 'Número inválido.'
    }

    return error
  }

  async function handleClickAdd() {
    const error = handleError()

    if (error) setError(true)
    else {
      const cellphoneOnlyNumbers = cellphone.replace(/[^0-9\s]/g, '')
      const [ddd, number] = cellphoneOnlyNumbers.split(' ')

      try {
        await runAsync({ ddd, number })
      } catch (error) {
        const axiosError = error as AxiosError<{ message: string }>
        if (axiosError?.response?.data?.message === 'Phone already exists') {
          return navigate('/numeros-contato', { state: { previousPath: path } })
        }
      }

      navigate('/numero-sucesso', { state: { previousPath: path } })
    }
  }

  function handleCellphoneChange(event: ChangeEvent<HTMLFuelTextFieldElement>) {
    const target = event.nativeEvent.target as HTMLInputElement

    setCellphone(target.value)

    setTimeout(() => {
      setCellphone(maskJs('(99) 99999-9999', target.value))
    }, 10)
  }

  function handleKeyDown() {
    setError(false)
  }

  return (
    <>
      <Styled.Title data-testid="add-number-title">Adicionar número de contato</Styled.Title>
      <Styled.Subtitle data-testid="add-number-subtitle" displayInline>
        Você só pode adicionar números de celular, se possível com WhatsApp.
      </Styled.Subtitle>
      <FuelTextField
        hint={hint}
        state={state}
        label="Número do celular"
        onInput={handleCellphoneChange}
        onKeyDown={handleKeyDown}
        value={cellphone}
        maxlength={15}
        type="tel"
        data-testid="add-number-text-field"
      />
      <Styled.ConfirmButton data-testid="confirm-button" onClick={handleClickAdd} isLoading={loading}>
        Adicionar
      </Styled.ConfirmButton>
    </>
  )
}

export default AddNumber
